// Keep /api on the current origin and turn an expired session into one app-wide
// event. The App owns auth state; this module only observes the response.
const API_BASE = window.location.origin;
export const AUTH_EXPIRED_EVENT = 'lexilamp:auth-expired';
export const AUTH_RESTORED_EVENT = 'lexilamp:auth-restored';

const nativeFetch = window.fetch;
const origFetch = nativeFetch.bind(window);
let authExpiryNotified = false;

export const resetAuthExpiryNotification = () => {
  authExpiryNotified = false;
};

window.addEventListener(AUTH_RESTORED_EVENT, resetAuthExpiryNotification);

const getPathname = (input) => {
  const rawUrl = typeof input === 'string' ? input : input?.url;
  return new URL(rawUrl || window.location.href, window.location.origin).pathname;
};

const hasAuthorizationHeader = (input, init) => {
  const headers = init?.headers || input?.headers;
  if (!headers) return false;
  if (typeof headers.get === 'function') return Boolean(headers.get('Authorization'));
  return Object.keys(headers).some((key) => key.toLowerCase() === 'authorization' && headers[key]);
};

export const shouldNotifyAuthExpired = (input, init = {}) => {
  const pathname = getPathname(input);
  if (!pathname.startsWith('/api/') || pathname === '/api/login') return false;
  return hasAuthorizationHeader(input, init) || Boolean(localStorage.getItem('token'));
};

export const notifyAuthExpired = () => {
  if (authExpiryNotified) return;
  authExpiryNotified = true;
  window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
};

export const clearExpiredSession = (setToken) => {
  localStorage.removeItem('token');
  setToken(null);
};

const handleResponse = (response, input, init) => {
  if (response.status === 401 && shouldNotifyAuthExpired(input, init)) notifyAuthExpired();
  return response;
};

const withLocale = (options = {}) => {
  const locale = localStorage.getItem('lexilab.locale') || 'en';
  return {
    ...options,
    headers: { 'Accept-Language': locale, ...(options.headers || {}) },
  };
};

window.fetch = (input, init) => {
  try {
    if (typeof input === 'string') {
      const request = input.startsWith('/api')
        ? origFetch(`${API_BASE}${input}`, withLocale(init))
        : origFetch(input, init);
      return request.then((response) => handleResponse(response, input, init));
    }

    if (input instanceof Request) {
      const url = new URL(input.url || '', window.location.origin);
      if (url.pathname.startsWith('/api')) {
        const sameOrigin = `${API_BASE}${url.pathname}${url.search}`;
        const request = new Request(sameOrigin, input);
        return origFetch(request, withLocale(init)).then((response) => handleResponse(response, input, init));
      }
      return origFetch(input, init);
    }

    return origFetch(input, init).then((response) => handleResponse(response, input, init));
  } catch (error) {
    return origFetch(input, init);
  }
};
